import { useEffect, useState } from "react";
import { Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { DatePicker } from 'antd';
import SelectSearchable from "../../SelectSeachble/SelectSearchble";
import { GetExamenesAll } from "../../../Service/Service.examen";
import { GetPacientesAll } from "../../../Service/Service.paciente";
import { ControllerListarSegurosClinica } from "../../../Service/Services.seguros";
import { GetTokenDecoded } from "../../../utils/storeUsuario";

const { RangePicker } = DatePicker;

const FiltrosFacturas = ({ data }) => {

    const { show, handleClose, filters, updateFilters } = data;

    const [loading, setLoading] = useState(false);
    const [localFilters, setLocalFilters] = useState(filters);

    const [examen, setExamen] = useState([]);
    const [selectedExamenOption, setSelectedExamenOption] = useState(null);

    const [paciente, setPaciente] = useState([]);
    const [selectedPacienteOption, setSelectedPacienteOption] = useState(null);

    const [seguro, setSeguro] = useState([]);
    const [selectedSeguroOption, setSelectedSeguroOption] = useState(null);

    const [estado, setEstado] = useState([]);
    const [selectedEstadoOption, setSelectedEstadoOption] = useState(null);    

    const handleFilterInvoices = async () => {
        try {
            setLoading(true);
            const { rangoFechas } = localFilters;

            const filtrosFinales = {
                ...localFilters,
                fecha_inicial: rangoFechas?.[0]?.format("YYYY-MM-DD"),
                //fecha_final: rangoFechas?.[1]?.format("YYYY-MM-DD")
                fecha_final: rangoFechas?.[1]
                ? rangoFechas[1].endOf("day").format("YYYY-MM-DD HH:mm:ss")
                : null
            };

            updateFilters(filtrosFinales);
            handleClose();

        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message || "Hubo un error al buscar documentos",
            });

        } finally {
            handleClose();
            setLoading(false);
        }
    }

    const loadExamenes = async (search = null) => {

        try {
            const result = await GetExamenesAll(1, 10, search);
            if (result && result.success) {
                const formattedData = result.data.map((d) => ({
                  value: d.IdExamenTipo,
                  label: `${d.codigo} - ${d.descripcion}`,
                }));
                setExamen(formattedData);
            }

        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message || "Hubo un error al buscar documentos",
            });

        }
    }

    const loadPacientes = async (search = null) => {

        try {
            const result = await GetPacientesAll(1, 10, search);
            if (result && result.success) {
                const formattedData = result.data.map((d) => ({
                  value: d.idpaciente,
                  label: `${d.cedula} - ${d.nombres_completos}`,
                }));
                setPaciente(formattedData);
            }

        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message || "Hubo un error al buscar documentos",
            });

        }
    }

    const loadSeguros = async () => {

        try {
            const dataSeguro = await ControllerListarSegurosClinica(GetTokenDecoded().idclinica);
            const segurosFiltrados = dataSeguro.filter(seg => seg.tipoSeguro.tipo === "SEGUROS");
            const segurosOptions = segurosFiltrados.map((seg) => ({ value: seg.idseguro, label: seg.nombre }));
            setSeguro(segurosOptions);

        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message || "Hubo un error al buscar documentos",
            });

        }
    }

    const loadEstados = async () => {

        const estado = [
            { value: "Por Cobrar", label: "Por Cobrar"},
            { value: "Facturado", label: "Facturado"},
            { value: "Eliminado", label: "Eliminado"}
        ];

        setEstado(estado);
    }

    const handleExamenChange = selectedOption => {
        setSelectedExamenOption(selectedOption);
        setLocalFilters({...localFilters, examen: selectedOption?.value});
    };

    const OnInputChangeExamen = (value) => {
        loadExamenes(value);
    };

    const handlePacienteChange = selectedOption => {
        setSelectedPacienteOption(selectedOption);
        setLocalFilters({...localFilters, paciente: selectedOption?.value});
    };

    const OnInputChangePaciente = (value) => {
        loadPacientes(value);
    };

    const handleSeguroChange = selectedOption => {
        setSelectedSeguroOption(selectedOption);
        setLocalFilters({...localFilters, seguro: selectedOption?.value});
    };

    const handleEstadoChange = selectedOption => {
        setSelectedEstadoOption(selectedOption);
        setLocalFilters({...localFilters, estado: selectedOption?.value});
    };

    useEffect(() => {
        if (show) {
            setLocalFilters(filters);
            loadExamenes();
            loadPacientes();
            loadSeguros();
            loadEstados();
        }
    }, [show]);

    return (
        <>
            <style>
                {`
                .ant-picker-dropdown {
                    z-index: 12000 !important;
                }
            `}
            </style>

            <Offcanvas keyboard={false}
                show={show}
                onHide={handleClose}
                placement="end"
                style={{ zIndex: 10000, overflow: "visible" }}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Buscar Facturas por Cobrar</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="d-flex flex-column">

                    <div className="h-auto">

                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group d-flex flex-column">
                                    <label>Fecha</label>
                                    <RangePicker
                                        value={localFilters.rangoFechas}
                                        onChange={(dates) => setLocalFilters({ ...localFilters, rangoFechas: dates })}
                                        getPopupContainer={() => document.body}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row pt-4">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Estado</label>
                                    <div className="w-auto">
                                        <SelectSearchable
                                            listCompany={estado}
                                            handleChange={handleEstadoChange}
                                            placeholder="Buscar estado"
                                            selectedOption={selectedEstadoOption}
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>                                             

                        <div className="row pt-4">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Seguros</label>
                                    <div className="w-auto">
                                        <SelectSearchable
                                            listCompany={seguro}
                                            handleChange={handleSeguroChange}
                                            placeholder="Buscar seguros"
                                            selectedOption={selectedSeguroOption}
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row pt-4">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Procedimientos</label>
                                    <div className="w-auto">
                                        <SelectSearchable
                                            listCompany={examen}
                                            handleChange={handleExamenChange}
                                            placeholder="Buscar procedimientos"
                                            selectedOption={selectedExamenOption}
                                            onInputChange={OnInputChangeExamen}
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row pt-4">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Pacientes</label>
                                    <div className="w-auto">
                                        <SelectSearchable
                                            listCompany={paciente}
                                            handleChange={handlePacienteChange}
                                            placeholder="Buscar pacientes"
                                            selectedOption={selectedPacienteOption}
                                            onInputChange={OnInputChangePaciente}
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="p-3 w-100 text-center mt-4"
                        style={{ position: 'absolute', bottom: 0, left: 0 }}>
                        <button className="btn btn-primary w-100"
                            onClick={handleFilterInvoices}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {" "}Por favor espere...
                                </>
                            ) : "Buscar"}
                        </button>
                    </div>


                </Offcanvas.Body>

            </Offcanvas>
        </>
    )
}

export default FiltrosFacturas;